import { Checkbox, FormControlLabel, Grid, useTheme } from "@material-ui/core";
import ToolGroupButton from "Components/ToolGroupButton/ToolGroupButton";
import ShapesList from "Constants/ShapesList";
import React, { useEffect, useState } from "react";
import showNotify from "Helpers/Notify";
import MuiButton from "Components/MuiButton/MuiButton";
import Translator from "Languages/Utility/Translator";
import { push } from "Helpers/History";
import { Refresh } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { saveNewUnitInfo } from "Stores/actions";
import { useSelector } from "react-redux";
import useScript from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import * as Icons from "react-bootstrap-icons"
import { useTranslation } from 'react-i18next';

const SelectShapes = ({
  onSelect,
  selectedShape,
  windGapHeight,
  windGapWidth,
  saveNewUnit,
  onExit,
  onClear,
}) => {
  const { t } = useTranslation();
  const [firstEnter, setFirstEnter] = useState(true);
  const { direction } = useTheme();
  const status = useScript("/assets/getBackToBack.js");
  const { newUnitInfo, rtlLayout } = useSelector((state) => ({
    newUnitInfo: state.design.newUnitInfo,
    rtlLayout: state.settings.rtlLayout
  }));
  const [designShape, setDesignShape] = useState(null);
  const [loading, setLoading] = useState(false);
  const [refreshDisable, setRefreshDisable] = useState(true);
  const [checkUnlimit, setCheckUnlimit] = useState(false);
  const [saveUnit, setSaveUnit] = useState(false);
  const [unitData, setUnitData] = useState(null);
  const [limeEmbed, setLimeEmbed] = useState(false);
  const [size, setSize] = useState({height: 500, width: 437});
  const dispatch = useDispatch();

  const onSubmit = async () => {
    setLoading(true);
    await designShape.CheckSizeB2B();
    setSaveUnit(true);
    setLoading(false);
    setFirstEnter(true);
  };

  const onCancel = () => {
    const id = read("unitId");
    if (id !== "undefined") {
      push(`/design/unit/${id}`)
    } else {
      push("/design")
    }
    onClear();
  };

  const checkboxUnlimitHandler = () => setCheckUnlimit(!checkUnlimit);

  const refresh = () => {
    setRefreshDisable(true);
    designShape.ResetB2B();
  };

  useEffect(() => {
    if(status === "ready" && !limeEmbed) {
      setLimeEmbed(true);
      const data = window.lime.embed(
          "getBackToBack",
          "openfl-content-B2B",
          0,
          0,
          null
      );
      setDesignShape(data);
    }
  }, [size, status]);

  useEffect(() => {
    try {
      let tgb = document.getElementById('ToolGroupButton');
      let grid = document.getElementById('openflContainer');
      let div = document.getElementById('openfl-content-B2B');
      grid.style.margin = 0;
      grid.style.padding = 0;
      grid.style.position = "relative";
      grid.style.height = '430px';
      div.style.width = `${grid.clientWidth-10}px`;
      div.style.height = `${grid.clientHeight-60}px`;
      setSize({height: div.clientHeight , width: div.clientWidth});
    } catch (err) {
      console.error('[catch error]', err)
    }
  },[])

  // Listen to B2B
  useEffect(() => {
    window.get_Error_C_Sharp_B2B = (arg) => {
      showNotify({ text: arg, customClass: "error" });
    };

    window.get_check_condition_B2B = () => {
      designShape.badkhorB2B(windGapWidth.toString(), windGapHeight.toString());
      designShape.is_conditionB2B(checkUnlimit.toString());
    };

    window.get_Check_B2B = (arg) => {
      if (arg === "1") {
        setRefreshDisable(false);
        designShape.FinishB2B();
      } else {
        setRefreshDisable(true);
        showNotify({
          text: t('dimensionsError'),
          customClass: "error",
        });
      }
    };

    window.get_FINISH_B2B = (arg) => {
      dispatch(saveNewUnitInfo(arg));
    };

    window.Get_W_HB2B = (str) => {
      let wh = str.split(",");
      let uWidth = Math.round(wh[0], 0);
      let uHeight = Math.round(wh[1], 0);
      setUnitData({ width: uWidth, height: uHeight });
    };
  }, [checkUnlimit, designShape, windGapHeight, windGapWidth]);

  // Draw shape
  useEffect(() => {
    if (designShape) {
      designShape.drawShapeB2B(JSON.stringify(selectedShape.str1));
      designShape.C_Scale(size.width.toString(), size.height.toString());
      designShape.C_Scale("0", "0");
      designShape.drawShapeB2B(JSON.stringify(selectedShape.str1));
      let div = document.getElementById('openfl-content-B2B');
      try {
        let convas = div.childNodes[0];
        convas.style.position = "absolute";
        convas.style.maxWidth = div.clientWidth;
        convas.style.maxHeight = div.clientHeight;
        convas.style.top = '5px';
        convas.style.left = '5px';
      } catch (err) {
        console.error("[catch error]", err);
      }
      //!  ------------------------  set scroll to top
      if(firstEnter) {
        setTimeout(() => {
          try {
            const nudm = document.getElementById('new-unit-designer-mian');
            nudm.scrollTo(0, 0);
            setFirstEnter(false);
          } catch (err) {
            console.error('[catch error]', err)
          }
        }, 300);
      }
      //!  ------------------------  set scroll to top
    }
  }, [designShape, selectedShape]);

  // Post data to save unit
  useEffect(() => {
    if (saveUnit && !refreshDisable && unitData && newUnitInfo) {
      saveNewUnit(unitData, newUnitInfo);
    }
  }, [refreshDisable, saveUnit, unitData, newUnitInfo]);

  return (
    <>
      <Grid container className={`select-shape-new-unit ${direction === 'rtl' ? "text-right" : "text-left" }`}>
        <Grid item sm={5} xs={12} className="d-flex flex-wrap">
          {
            Object.keys(ShapesList).map((key) => {
              return (
                <div key={key} className="inner-shape">
                  {
                    ShapesList[key].map((item) => {
                      return (
                        <div key={item.key} className=" p-2 m-2 border rounded">
                          <ToolGroupButton
                            className=""
                            selectedTool={selectedShape}
                            onClick={onSelect}
                            options={item.sub}
                          />
                        </div>
                      );
                    })
                  }
                </div>
              );
            })
          }
        </Grid>
        <Grid item sm={7} xs={12} className="pt-2">
          <div id='openflContainer' className="openfl-new-unit">
            <div id="openfl-content-B2B"/>
            <div className="remove-change" onClick={refresh}>
              <Refresh />
              <Translator id="default_settings" />
            </div>
          </div>
          <div className="pt-3">
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkUnlimit}
                  onChange={checkboxUnlimitHandler}
                  value="checkUnlimit"
                  color="primary"
                />
              }
              label={<span>{t('technical_option')}</span>}
            />
            {/* <MuiButton
              color="secondary"
              innerIcon={<Refresh />}
              onClick={refresh}
              // disabled={refreshDisable}
              title={t('default_settings')}
              fullwidthOnSm
            /> */}
          </div>
        </Grid>
      </Grid>
      <Grid container className="new-unit-action-bar">
          <MuiButton
            loading={loading}
            color="primary"
            onClick={onSubmit}
            title={<Translator id="zakhire" />}
            innerIcon={<Icons.Floppy />}
          />
          <MuiButton
            loading={loading}
            variant="contained"
            onClick={onExit}
            title={<Translator id="enseraf" />}
          />
      </Grid>
    </>
  );
};

export default SelectShapes;